/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIPatchedUserPreferencesRequestLanguage } from './APIPatchedUserPreferencesRequestLanguage';
import {
    APIPatchedUserPreferencesRequestLanguageFromJSON,
    APIPatchedUserPreferencesRequestLanguageFromJSONTyped,
    APIPatchedUserPreferencesRequestLanguageToJSON,
} from './APIPatchedUserPreferencesRequestLanguage';

/**
 * 
 * @export
 * @interface APIUserPreferences
 */
export interface APIUserPreferences {
    /**
     * 
     * @type {APIPatchedUserPreferencesRequestLanguage}
     * @memberof APIUserPreferences
     */
    language?: APIPatchedUserPreferencesRequestLanguage;
}

/**
 * Check if a given object implements the APIUserPreferences interface.
 */
export function instanceOfAPIUserPreferences(value: object): value is APIUserPreferences {
    return true;
}

export function APIUserPreferencesFromJSON(json: any): APIUserPreferences {
    return APIUserPreferencesFromJSONTyped(json, false);
}

export function APIUserPreferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIUserPreferences {
    if (json == null) {
        return json;
    }
    return {
        
        'language': json['language'] == null ? undefined : APIPatchedUserPreferencesRequestLanguageFromJSON(json['language']),
    };
}

export function APIUserPreferencesToJSON(value?: APIUserPreferences | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'language': APIPatchedUserPreferencesRequestLanguageToJSON(value['language']),
    };
}

